/**
 * Hash determinístico do domínio de flows.
 *
 * A implementação fica atrás de uma interface própria para que uma troca
 * futura (por exemplo, SHA-256 via WebCrypto assíncrono no backend) não force
 * mudança nos chamadores. Requisitos desta etapa:
 *   * browser-compatible: nenhuma API exclusiva do Node é usada;
 *   * síncrona e pura: mesmo input, mesmo output, sem relógio nem random;
 *   * sem dependência nova: nada é instalado para calcular o hash.
 */

export interface FlowHasher {
  readonly algorithm: string;
  hash(input: string): string;
}

function fnv1a(input: string, seed: number): number {
  let hash = seed >>> 0;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 16777619) >>> 0;
  }
  return hash >>> 0;
}

/**
 * Quatro passes FNV-1a com sementes distintas produzem 128 bits em hexadecimal.
 * Não é hash criptográfico e não deve ser usado como prova de autenticidade;
 * ele identifica equivalência semântica entre planos compilados.
 */
export const flowHasher: FlowHasher = {
  algorithm: "fnv1a-128",
  hash(input: string): string {
    const seeds = [2166136261, 16777619, 2246822519, 3266489917];
    return seeds
      .map((seed) => fnv1a(input, seed).toString(16).padStart(8, "0"))
      .join("");
  },
};

export function flowContentHash(serialized: string, hasher: FlowHasher = flowHasher): string {
  return `${hasher.algorithm}:${hasher.hash(serialized)}`;
}
